import React from 'react';
import BaseModal from 'flow/components/ui-components/BaseModal';

interface Props {
    title?: string;
    description?: string;
    onRemove?: () => void;
}

const RemoveDialog = ({ title, description, onRemove }: Props) => (
    <BaseModal open={true} header={title} onRemove={onRemove}>
        {description}
    </BaseModal>
);

export default RemoveDialog;
